<!--  -->
<template>
    <div>
        <dialog-slot :isTitle="true" v-bind="$attrs" v-on="$listeners" leftBtnText="立即支付" @handleLeftBtn="pay">
            <template v-slot:title> 支付方式 </template>
            <template v-slot:content>
                <div class="parkingPay-billInfo-footer">
                    <van-radio-group v-model="payType">
                        <van-cell-group :border="false">
                            <van-cell clickable @click="radio = '1'">
                                <template #title>
                                    <div class="parkingPay-footer-type flex align-center">
                                        <img src="@/assets/images/pay/wallet.png" alt="" />
                                        <div class="parkingPay-footer-payforpocket">
                                            <p>余额支付</p>
                                            <p class="parkingPay-pocket-balance">当前余额：{{ wallet }}元</p>
                                        </div>
                                    </div>
                                </template>
                                <template #right-icon>
                                    <van-radio name="1" />
                                </template>
                            </van-cell>
                            <van-cell clickable @click="radio = '2'">
                                <template #title>
                                    <div class="parkingPay-footer-type flex align-center">
                                        <img src="@/assets/images/pay/wechat.png" alt="" />
                                        <div class="parkingPay-footer-payforpocket">
                                            <p>微信支付</p>
                                        </div>
                                    </div>
                                </template>
                                <template #right-icon>
                                    <van-radio name="2" />
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
            </template>
        </dialog-slot>

        <loading :show="payLoading" text="支付中..." />
    </div>
</template>

<script>
import DialogSlot from "@/components/base/dialogSlot/dialog-slot.vue";
import Loading from "@/components/base/loading/loading.vue";
import { walletBalance, submitOneKeyPay } from "@/api/index";

export default {
    name: "PayDialog",
    components: {
        Loading,
        DialogSlot,
    },
    props: {
        //显示隐藏参数
        // showDialog: {
        //     type: Boolean,
        //     default: false,
        //     require: true,
        // },
        // 订单数组
        arrearList: {
            type: Array,
            default: () => [],
            require: true,
        },
        //订单支付金额
        AllMoney: {
            type: Number,
            default: 0,
            require: true,
        },
    },

    data() {
        return {
            payLoading: false, //支付遮罩回调
            payType: "1", // 支付类型 1:余额支付，2：微信支付
            wallet: 0, //余额余额
        };
    },

    mounted() {
        this.getwallet();
    },
    watch: {},
    methods: {
        //支付
        pay() {
            let obj = {
                arrearsDTOs: this.arrearList,
                goodDetail: "停车缴费", //商品详情
                goodSubject: "停车缴费", //商品标题
                merchants: this.payType == "2" ? "BESTPAY" : "WALLETPAY", //默认传BESTPAY  用余额支付时  传WALLETPAY
                orderMoney: this.AllMoney, //订单总金额
                payChannel: "TENPAY", //TENPAY 微信支付
            };
            if (this.payType == "1") {
                this.payLoading = true;
            }
            submitOneKeyPay(obj).then((res) => {
                console.log(res.data);
                if (res.code == 200) {
                    if (this.payType == "1") {
                        this.payLoading = false;
                        this.$toast("支付成功");
                        this.$emit("update:show", false);
                        this.$router.push({ name: "payResult" });
                    } else {
                        window.location.href = res.data.payUrl;
                    }
                }
            });
        },
        //获取余额余额
        getwallet() {
            walletBalance().then((res) => {
                if (res.code == 200) {
                    this.wallet = res.data;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.parkingPay-billInfo-footer {
    width: 100%;
    margin: 0 auto;
    padding: 0 26px 26px 26px;
    background-color: #fff;

    .parkingPay-billInfo-payType-text {
        font-size: 30px;
        color: #333333;
    }

    .parkingPay-footer-type {
        img {
            width: 40px;
            height: 38px;
            margin-right: 17px;
        }

        .parkingPay-footer-payforpocket {
            color: #666666;
            font-size: 28px;

            .parkingPay-pocket-balance {
                color: #999;
                font-size: 24px;
            }
        }
    }
}
</style>
